var _g, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 27,
    viewBox: "0 0 20 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M16.76 6.31784C16.104 6.31721 15.475 6.05632 15.0111 5.59242C14.5472 5.12853 14.2863 4.49954 14.2857 3.8435V0.40918H3.22913C2.37292 0.40918 1.55176 0.749227 0.946212 1.35455C0.340668 1.95987 0.000318175 2.7809 0 3.6371V23.1031C0.000954063 23.9589 0.341585 24.7793 0.94706 25.3841C1.55254 25.9889 2.37333 26.3286 3.22913 26.3286H16.5008C16.925 26.3287 17.345 26.2453 17.7369 26.0831C18.1288 25.9209 18.485 25.6831 18.7849 25.3832C19.0849 25.0834 19.3229 24.7273 19.4852 24.3355C19.6476 23.9436 19.7311 23.5236 19.7311 23.0995V6.31784H16.76Z",
    fill: "#FF9908"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7306 6.31784H16.7595C16.1035 6.31721 15.4745 6.05632 15.0106 5.59242C14.5467 5.12853 14.2858 4.49954 14.2852 3.8435V0.40918L19.7306 6.31784Z",
    fill: "#FF9908"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1206 16.2396H12.8066V10.9286C12.8066 10.7507 12.7359 10.58 12.6101 10.4542C12.4844 10.3284 12.3137 10.2578 12.1358 10.2578H8.77591C8.59801 10.2578 8.42739 10.3284 8.3016 10.4542C8.1758 10.58 8.10513 10.7507 8.10513 10.9286V16.2396H6.78516V10.4798C6.78547 10.0717 6.94782 9.68037 7.23651 9.39191C7.5252 9.10344 7.91661 8.94141 8.32472 8.94141H12.5738C12.9818 8.94141 13.3731 9.10348 13.6616 9.39198C13.9501 9.68048 14.1122 10.0718 14.1122 10.4798L14.1206 16.2396Z",
    fill: "#FF9908"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5615 17.7968C13.4217 17.7968 14.119 17.0994 14.119 16.2392C14.119 15.379 13.4217 14.6816 12.5615 14.6816C11.7013 14.6816 11.0039 15.379 11.0039 16.2392C11.0039 17.0994 11.7013 17.7968 12.5615 17.7968Z",
    fill: "#FF9908"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55366 17.7968C7.41388 17.7968 8.11122 17.0994 8.11122 16.2392C8.11122 15.379 7.41388 14.6816 6.55366 14.6816C5.69344 14.6816 4.99609 15.379 4.99609 16.2392C4.99609 17.0994 5.69344 17.7968 6.55366 17.7968Z",
    fill: "#FF9908"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWma);
export default __webpack_public_path__ + "static/media/WMA.4ef7ceed0871e2a302f1da38852b28d4.svg";
export { ForwardRef as ReactComponent };